import { render, staticRenderFns } from "./medicineMessage.vue?vue&type=template&id=552f43c6&scoped=true&"
import script from "./medicineMessage.vue?vue&type=script&lang=js&"
export * from "./medicineMessage.vue?vue&type=script&lang=js&"
import style0 from "./medicineMessage.vue?vue&type=style&index=0&id=552f43c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f43c6",
  null
  
)

export default component.exports